import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect,ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { langKey, LanguageActionTypes, Languages } from './lang.reducer';
import { SessionStorageService } from '@app/core';

@Injectable()
export class LangEffects {

  saveBg$;
  saveEn$;
  constructor(
    private actions$: Actions<Action>,
    private sessionStorage: SessionStorageService,
  ) {}

 // @Effect({ dispatch: false })
  saveBG(): Observable<Action> {
    this.saveBg$ = createEffect(()=>{
      return this.actions$
      .pipe(ofType(LanguageActionTypes.SET_BG),
        tap(action =>
          this.sessionStorage.setItem(langKey, Languages.bg)
        )
      );
    },{dispatch:false})
   return this.saveBg$
  }

  //@Effect({ dispatch: false })
  saveEN(): Observable<Action> {
    this.saveEn$ = createEffect(()=>{
      return this.actions$
      .pipe(ofType(LanguageActionTypes.SET_EN),
        tap(action =>
          this.sessionStorage.setItem(langKey, Languages.en)
        )
      );
    },{dispatch:false})
   return this.saveEn$;
  }
}
